// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import {
    chain,
    DispatchSetInitialValues,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";

export const XngDispatchSetInitialValues = (props: any) => {
    const account = getCurrentAccountState(props.getState()).value;
    const session = props.getState().context?.session;
    const clonedAccount: any = { ...account };

    if (clonedAccount && clonedAccount.properties && !clonedAccount.properties?.language?.length && session?.language) {
        const properties: any = { ...(clonedAccount as any).properties };
        properties.language = session?.language?.id;
        (clonedAccount as any).properties = properties;
    }

    props.dispatch({
        type: "xAccountSettings/updateAccountSettings",
        ...clonedAccount,
    } as any);
};

addToChainAfter(chain, DispatchSetInitialValues, XngDispatchSetInitialValues);
